import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { Group } from '../../../models/group.model';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from "../../../components/modal/modal.component";
import { CreateGroupComponent } from '../create-group/create-group.component';
import { GroupService } from '../group.service';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-list-group',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    ModalComponent,
    CreateGroupComponent,
    PaginatorModule
],
  templateUrl: './list-group.component.html'
})
export class ListGroupComponent implements OnInit {

  searchTerm: string = '';
  totalRecords: number = 0; 
  groups: Group[] = [];
  loading: boolean =  true;
  formVisible: boolean = false;
  groupId!: number | null;

  first: number = 0;
  rows: number = 5;
  currentPage: number = 1;

  constructor(private location: Location, private groupService: GroupService){

  }
  
  ngOnInit(): void {
    this.getData();
  }

  closeModal(){
    this.groupId = null;
  }

  getData(){
    this.groupService.getAll(this.searchTerm, null, true, this.currentPage).subscribe({
      next: (data) => {
        console.log(data)
        this.groups = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error:(error) => {
        this.loading = false;
      }
    })
  }

   onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  edit(group: Group){
    this.groupId = group.id;
    this.changeModal();
  };

  createGroup()
  {
    this.changeModal();
  }

  changeModal(){
    this.formVisible = !this.formVisible;
  }

  goBack(){
    this.location.back();
  }

  onFormSubmit(){
    this.changeModal();
    this.getData();
  }
}
